import { gate } from 'hub-http/gates';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import { useMemo } from 'react';
export default function useIsUngatedForNewFrameworkFolders() {
  const hasAllGates = useHasAllGates();
  return useMemo(() => hasAllGates([gate('Email:FrameworkFolders')]), [hasAllGates]);
}